import LoadingAnimation from './LoadingAnimation';

export default LoadingAnimation;
